export default "__VITE_ASSET__DDVRg$ph__"